package fr.manyverse.app.infrastructure.audio

// Web Audio API decodeAudioData is async; not compatible with a sync interface.
actual fun extractAudioDurationSeconds(bytes: ByteArray): Int? = null
